import { User } from 'types/user';

export const users: User[] = [
  {
    lastName: 'Frank',
    firstName: 'Bob',
    id: 'f9797740-e048-423b-9dfe-7bf024e7237f',
  },
  {
    lastName: 'Frank',
    firstName: 'Ivan',
    id: '51d8a476-e2f3-4f16-9847-f2a915d717b8',
  },
  {
    lastName: 'Frank',
    firstName: 'Judy',
    id: 'ae027491-c4c2-48f6-a0cf-b501d1a3b981',
  },
];
